import { Toast } from 'antd-mobile';
import moment from 'moment';
import { MESSAGE_CLOSE_NOTICE_STORAGE_KEY } from '@/constant';
import {
  jsGetCookie,
  getAppInfo,
  jsGetProxyAddress,
  isLoginedNative,
  jsCheckPermission,
} from './bridge';
import { getStorage } from './storage';

// 兼容app-ip通信方案，获取代理地址的通用方法
const getProxyConfig = async () => {
  let proxy = getLocalStorage('proxy') || '';
  // if (!proxy) {
  try {
    const appRes = await jsGetProxyAddress();
    if (appRes && appRes.code === 0 && appRes.data && appRes.data.proxy) {
      proxy = appRes.data.proxy;
      setLocalStorage('proxy', proxy);
    }
  } catch (e) {
    console.log('catch getProxyConfig error: ', e);
  }
  // }
  return proxy;
};

//  兼容app-ip通信方案,提取构建host配置的通用方法
const buildHostConfig = (currentHost, proxy, hostConfig, apiPath) => {
  if (currentHost.includes('127.0.0.1') && proxy) {
    hostConfig[proxy] = `${proxy}/api/${apiPath}`;
  }
  return hostConfig[currentHost] || hostConfig[proxy] || hostConfig.default;
};

export async function getHost(predomain = 'reward') {
  let currentHost = window.location.host;
  const domain = `${predomain}-box`;
  const hostConfig = {
    default: '',
    'h5-box.onethingpcs.com': `//${domain}.onethingpcs.com`,
    'h5-box-test.onethingpcs.com': `//${domain}-test.onethingpcs.com`,
    // 'h5-box-test.onethingpcs.com': '', // 临时测试
    'h5-box-test2.onethingpcs.com': `//${domain}-test.onethingpcs.com`,
    'app.yfanqie.com': `//app.yfanqie.com/api/${domain}`,
    'app.xingyouyun.com': `//app.xingyouyun.com/api/${domain}`,
    'app.onethingcloud.com': `//app.onethingcloud.com/api/${domain}`,
    'app-test.onethingcloud.com': `//app-test.onethingcloud.com/api/${domain}`,
    'app-pre.onethingcloud.com': `//app-pre.onethingcloud.com/api/${domain}`,
  };
  const proxy = await getProxyConfig();
  return buildHostConfig(currentHost, proxy, hostConfig, domain);
}

export async function getWxMallHost() {
  let currentHost = window.location.host;
  const hostConfig = {
    default: '',
    'h5-box.onethingpcs.com': '//wxy-ml.onethingpcs.com',
    'h5-box-test.onethingpcs.com': '//wxy-ml-test.onethingpcs.com',
    'h5-box-test2.onethingpcs.com': '//wxy-ml-test.onethingpcs.com',
    'app.yfanqie.com': `//app.yfanqie.com/api/wxy-ml`,
    'app.xingyouyun.com': `//app.xingyouyun.com/api/wxy-ml`,
    'app.onethingcloud.com': `//app.onethingcloud.com/api/wxy-ml`,
    'app-test.onethingcloud.com': `//app-test.onethingcloud.com/api/wxy-ml`,
    'app-pre.onethingcloud.com': `//app-pre.onethingcloud.com/api/wxy-ml`,
  };
  const proxy = await getProxyConfig();
  return buildHostConfig(currentHost, proxy, hostConfig, 'wxy-ml');
}

export async function getWxCloudMallHost() {
  let currentHost = window.location.host;
  const hostConfig = {
    default: '',
    'h5-box.onethingpcs.com': '//api-mall.onethingcloud.com',
    'h5-box-test.onethingpcs.com': '//api-mall-test.onethingcloud.com',
    'app.yfanqie.com': `//app.yfanqie.com/api/mall`,
    'app.xingyouyun.com': `//app.xingyouyun.com/api/mall`,
    'app.onethingcloud.com': `//app.onethingcloud.com/api/mall`,
    'app-test.onethingcloud.com': `//app-test.onethingcloud.com/api/mall`,
    'app-pre.onethingcloud.com': `//app-pre.onethingcloud.com/api/mall`,
  };
  const proxy = await getProxyConfig();
  return buildHostConfig(currentHost, proxy, hostConfig, 'mall');
}

export async function getUserLevelHost() {
  let currentHost = window.location.host;
  const hostConfig = {
    default: '',
    'h5-box.onethingpcs.com': '//wxy-ul.onethingpcs.com',
    'h5-box-test.onethingpcs.com': '//device-box-test.onethingpcs.com',
    'h5-box-test2.onethingpcs.com': '//device-box-test.onethingpcs.com',
    'app.yfanqie.com': `//app.yfanqie.com/api/wxy-ul`,
    'app.xingyouyun.com': `//app.xingyouyun.com/api/wxy-ul`,
    'app.onethingcloud.com': `//app.onethingcloud.com/api/wxy-ul`,
    'app-test.onethingcloud.com': `//app-test.onethingcloud.com/api/wxy-ul`,
    'app-pre.onethingcloud.com': `//app-pre.onethingcloud.com/api/wxy-ul`,
  };
  const proxy = await getProxyConfig();
  return buildHostConfig(currentHost, proxy, hostConfig, 'wxy-ul');
}

// export function getAuthHost() {
//   let currentHost = window.location.host;
//   const hostConfig = {
//     default: '',
//     'h5-box.onethingpcs.com': '//h5.snodehome.com',
//     'h5-box-test.onethingpcs.com': 'http://192.168.208.214',
//     'h5-box-test2.onethingpcs.com': 'http://192.168.208.214',
//   };
//    const host = hostConfig[currentHost] || hostConfig[proxy] || hostConfig.default;
//   return host;
// }

export async function getMallHost() {
  const currentHost = window.location.host;
  const hostConfig = {
    default: '',
    'h5-box.onethingpcs.com': 'https://api-mall-box.onethingpcs.com',
    'h5-box-test.onethingpcs.com': 'https://api-mall-box-test.onethingpcs.com',
    'h5-box-test2.onethingpcs.com': 'https://api-mall-box-test.onethingpcs.com',
    'app.yfanqie.com': `//app.yfanqie.com/api/mall-box`,
    'app.xingyouyun.com': `//app.xingyouyun.com/api/mall-box`,
    'app.onethingcloud.com': `//app.onethingcloud.com/api/mall-box`,
    'app-test.onethingcloud.com': `//app-test.onethingcloud.com/api/mall-box`,
    'app-pre.onethingcloud.com': `//app-pre.onethingcloud.com/api/mall-box`,
  };
  const proxy = await getProxyConfig();
  return buildHostConfig(currentHost, proxy, hostConfig, 'mall-box');
}

export async function getRecruitHost() {
  const currentHost = window.location.host;
  const hostConfig = {
    default: '',
    'h5-box.onethingpcs.com': '//api-recruit.onethingpcs.com',
    'h5-box-test.onethingpcs.com': '//api-recruit-test.onethingpcs.com',
    'h5-box-test2.onethingpcs.com': '//api-recruit-test.onethingpcs.com',
    'app.yfanqie.com': `//app.yfanqie.com/api/recruit`,
    'app.xingyouyun.com': `//app.xingyouyun.com/api/recruit`,
    'app.onethingcloud.com': `//app.onethingcloud.com/api/recruit`,
    'app-test.onethingcloud.com': `//app-test.onethingcloud.com/api/recruit`,
    'app-pre.onethingcloud.com': `//app-pre.onethingcloud.com/api/recruit`,
  };
  const proxy = await getProxyConfig();
  return buildHostConfig(currentHost, proxy, hostConfig, 'recruit');
}

export async function getDownloadHost() {
  const currentHost = window.location.host;
  const hostConfig = {
    default: '',
    'h5-box.onethingpcs.com': '//control-test.onethingcloud.com',
    'h5-box-test.onethingpcs.com': '//control-test.onethingcloud.com',
    'h5-box-test2.onethingpcs.com': '//control-test.onethingcloud.com',
    'app.yfanqie.com': `//app.yfanqie.com/api/control`,
    'app.xingyouyun.com': `//app.xingyouyun.com/api/control`,
    'app.onethingcloud.com': `//app.onethingcloud.com/api/control`,
    'app-test.onethingcloud.com': `//app-test.onethingcloud.com/api/control`,
    'app-pre.onethingcloud.com': `//app-pre.onethingcloud.com/api/control`,
  };
  const proxy = await getProxyConfig();
  return buildHostConfig(currentHost, proxy, hostConfig, 'control');
}

export async function getAccountHost() {
  const currentHost = window.location.host;
  const hostConfig = {
    default: '',
    'h5-box.onethingpcs.com': '//account-box.onethingpcs.com',
    'h5-box-test.onethingpcs.com': '//account-box-test.onethingpcs.com',
    'h5-box-test2.onethingpcs.com': '//account-box-test.onethingpcs.com',
    'app.yfanqie.com': `//app.yfanqie.com/api/account-box`,
    'app.xingyouyun.com': `//app.xingyouyun.com/api/account-box`,
    'app.onethingcloud.com': `//app.onethingcloud.com/api/account-box`,
    'app-test.onethingcloud.com': `//app-test.onethingcloud.com/api/account-box`,
    'app-pre.onethingcloud.com': `//app-pre.onethingcloud.com/api/account-box`,
  };
  const proxy = await getProxyConfig();
  return buildHostConfig(currentHost, proxy, hostConfig, 'account-box');
}

export async function getConsolePropHost() {
  const currentHost = window.location.host;
  const hostConfig = {
    default: '',
    'h5-box.onethingpcs.com': '//device-box.onethingpcs.com',
    'h5-box-test.onethingpcs.com': '//api-consolepro-test.onethingcloud.com',
    'h5-box-test2.onethingpcs.com': '//api-consolepro-test.onethingcloud.com',
    'app.yfanqie.com': '//app.yfanqie.com/api/consolepro',
    'app.xingyouyun.com': '//app.xingyouyun.com/api/consolepro',
    'app.onethingcloud.com': '//app.onethingcloud.com/api/consolepro',
    'app-test.onethingcloud.com': '//app-test.onethingcloud.com/api/consolepro',
    'app-pre.onethingcloud.com': '//app-pre.onethingcloud.com/api/consolepro',
  };
  const proxy = await getProxyConfig();
  return buildHostConfig(currentHost, proxy, hostConfig, 'consolepro');
}

export function getShareHost() {
  const currentHost = window.location.host;
  const hostConfig = {
    default: 'https://act2.walk-live.com',
    'h5-box.onethingpcs.com': 'https://act2.walk-live.com',
    'h5-box-test.onethingpcs.com': 'https://act-test.walk-live.com',
    'h5-box-test2.onethingpcs.com': 'https://act-test.walk-live.com',
    'app.yfanqie.com': 'https://act2.walk-live.com',
    'app.xingyouyun.com': 'https://act2.walk-live.com',
    'app.onethingcloud.com': 'https://act2.walk-live.com',
    'app-test.onethingcloud.com': 'https://act-test.walk-live.com',
    'app-pre.onethingcloud.com': 'https://act2.walk-live.com',
  };
  if (currentHost.includes('127.0.0.1')) {
    return 'https://act2.walk-live.com';
  }
  const host = hostConfig[currentHost] || hostConfig.default;
  return host;
}

export async function getAppVersion() {
  const appInfo = await getAppInfo();
  return appInfo && appInfo.code === 0 && appInfo.data.version;
}

export async function getAppChannel() {
  const appInfo = await getAppInfo();
  return appInfo && appInfo.code === 0 && appInfo.data.channel;
}

export async function platFormIsIos() {
  const appInfo = await getAppInfo();
  const origin = appInfo && appInfo.code === 0 && appInfo.data.origin;
  return origin === '2' || origin === '4';
}

// 检查并更新登录态，已在layout中调用，页面无需再调用
export const checkLogin = async callback => {
  const appRes = await isLoginedNative();
  // console.log('checkLogin登录态: ', appRes);
  if (appRes?.code === 0) {
    const newStatus = appRes.data.status;
    window.g_app._store.dispatch({
      type: 'user/updateLoginState',
      payload: newStatus,
    });
    // 登录成功执行回调
    if (newStatus && callback) callback();
  }
};

// 检查并更新AppInfo，避免重复获取信息，已在layout中调用，页面无需再调用
export const getAndUpdateAppInfo = async () => {
  const appRes = await getAppInfo();
  // console.log('AppInfo: ', appRes);
  if (appRes && appRes.code === 0) {
    const appInfo = appRes.data;
    // 只有在登录态改变的时候才会更新
    window.g_app._store.dispatch({
      type: 'user/save',
      payload: appInfo,
    });
  }
};

export const getProxyAddressInfo = async () => {
  try {
    const appRes = await jsGetProxyAddress();
    if (appRes && appRes.code === 0 && appRes.data && appRes.data.proxy) {
      const proxy = appRes.data.proxy;
      setLocalStorage('proxy', proxy);
    }
  } catch (e) {
    console.log('catch getProxyAddressInfo error: ', e);
  }
};

export function getCurrentDate() {
  const date = new Date();
  let curYear = date.getFullYear();
  let curMonth = date.getMonth() + 1;
  // let curDay = date.getDate();
  // if (curDay === 1) {
  //   if (curMonth !== 1) {
  //     curMonth -= 1;
  //   } else {
  //     curMonth = 12;
  //     curYear -= 1;
  //   }
  // }
  curMonth = curMonth < 10 ? `0${curMonth}` : curMonth;
  return `${curYear}${curMonth}`;
}

export function getSixtyDateBefore() {
  const date = new Date().valueOf();
  const sixtyDayBefore = date - 60 * 24 * 60 * 60 * 1000;
  return new Date(sixtyDayBefore);
}

export function getThereMonthBefore() {
  const currentDate = new Date();
  let currentYear = currentDate.getFullYear();
  let currentMonth = currentDate.getMonth();
  let targetMonth = currentMonth - 3;
  if (targetMonth < 0) {
    targetMonth += 12;
    currentYear -= 1;
  }
  return new Date(currentYear, targetMonth, 1);
}

export function formatDate(date) {
  if (!date) return '';
  if (!(date instanceof Date)) {
    date = new Date(date);
  }
  const curYear = date.getFullYear();
  let curMonth = date.getMonth() + 1;
  curMonth = curMonth < 10 ? `0${curMonth}` : curMonth;
  let curDay = date.getDate();
  curDay = curDay < 10 ? `0${curDay}` : curDay;
  return `${curYear}-${curMonth}-${curDay}`;
}

export function formatDateToStr(date) {
  if (!date) return '';
  if (!(date instanceof Date)) {
    date = new Date(date);
  }
  const curYear = date.getFullYear();
  let curMonth = date.getMonth() + 1;
  curMonth = curMonth < 10 ? `0${curMonth}` : curMonth;
  let curDay = date.getDate();
  curDay = curDay < 10 ? `0${curDay}` : curDay;
  return `${curYear}${curMonth}${curDay}`;
}

export function getPrevDate(date) {
  if (!date) {
    return '';
  }
  let year = Number(date.substr(0, 4));
  let month = Number(date.substr(4));
  if (month === 1) {
    month = 12;
    year -= 1;
  } else {
    month -= 1;
  }
  month = month < 10 ? `0${month}` : month;
  return `${year}${month}`;
}

export function deepClone(obj) {
  let newobj;
  if (typeof obj !== 'object' || !obj) {
    return obj;
  } else {
    newobj = obj.constructor === Array ? [] : {};
    for (let i in obj) {
      newobj[i] = typeof obj[i] === 'object' ? deepClone(obj[i]) : obj[i];
    }
  }
  return newobj;
}

//var res = sortArrayByProperty(arr, 'loc', 'asc');
export function sortArrayByProperty(list, property, mode = 'asc') {
  let compareFn = null;
  //取第一项去，判断字段类型是数字还是字符串
  let firstProperty = list[0][property];
  let isNumer = firstProperty && isFinite(firstProperty);
  // console.log(isNumer);

  let compareNum = function(a, b) {
    let value1 = String(a[property]);
    let value2 = String(b[property]);
    if (mode === 'asc') {
      return value1 - value2;
    } else {
      return value2 - value1;
    }
  };

  let compareStr = function(a, b) {
    let value1 = String(a[property]);
    let value2 = String(b[property]);
    if (mode === 'asc') {
      return value1.localeCompare(value2);
    } else {
      return value2.localeCompare(value1);
    }
  };

  compareFn = isNumer ? compareNum : compareStr;
  let res = list.sort(compareFn);
  return res;
}

/* export function copyValue(value) {
  let selection = window.getSelection();
  selection.removeAllRanges();
  let range = document.createRange();
  let el = document.createElement('span');
  // console.log(value);
  el.innerText = value;
  el.style.position = 'absolute';
  el.style.right = '-9999px';
  el.style["user-select"] = "text";

  //添加dom
  document.body.appendChild(el);
  range.selectNodeContents(el);
  selection.addRange(range);
  document.execCommand("copy",false,null);
  selection.removeAllRanges();
  //移除dom
  document.body.removeChild(el);
} */

//网页被卷起来的高度（即浏览器滚动条滚动后隐藏的页面内容高度）
export function getScrollTop() {
  // let mySelf = this;
  let scrollTop = document.documentElement.scrollTop || window.pageYOffset || window.scrollY;
  return scrollTop;
}

// 写错了  这个逻辑是防抖
export function debounce(func, wait) {
  // console.log('防抖');
  let timeout = null;
  return function(args) {
    let _args = args;
    let context = this;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      func.call(context, _args);
    }, wait);
  };
}

/*
 * @Name 写入localStorage
 * @Param
 * @Return
 * @Author
 * @Readme
 */
export function setLocalStorage(key, value) {
  window.localStorage.setItem(key, value);
}

/*
 * @Name 读取localStorage
 * @Param
 * @Return
 * @Author
 * @Readme
 */
export function getLocalStorage(key) {
  return window.localStorage.getItem(key);
}

/*
 * @Name 删除localStorage
 * @Param
 * @Return
 * @Author
 * @Readme
 */
export function delLocalStorage(key) {
  window.localStorage.removeItem(key);
}

/**
 * 格式化时间戳
 * @param {Number} timestamp 时间戳（秒数）
 * @returns {String} xxxx-xx-xx
 */
export function formatTimestamp(timestamp) {
  if (!timestamp) return '--';
  const dateObj = new Date(timestamp * 1000);
  const year = dateObj.getFullYear();
  let month = dateObj.getMonth() + 1;
  month = month < 10 ? '0' + month : month;
  let date = dateObj.getDate();
  date = date < 10 ? '0' + date : date;
  return [year, month, date].join('-');
}

// 检查空对象
export function checkNullObject(obj = {}) {
  return Object.keys(obj).length === 0;
}

export function getParams(name, searchStr) {
  const url = searchStr || window.location.search;
  const reg = new RegExp('[\\?&]' + name + '=([^&]*)');
  const v = url.match(reg);
  return v === null ? null : v[1];
}

export function isNumber(num) {
  if (!num) return false;
  return typeof num === 'number';
}

export function addNumber(a, b) {
  let c, d, e;
  try {
    c = a.toString().split('.')[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split('.')[1].length;
  } catch (f) {
    d = 0;
  }
  return (e = Math.pow(10, Math.max(c, d))), (mulNumber(a, e) + mulNumber(b, e)) / e;
}

export function mulNumber(a, b) {
  let c = 0,
    d = a.toString(),
    e = b.toString();
  try {
    c += d.split('.')[1].length;
  } catch (f) {}
  try {
    c += e.split('.')[1].length;
  } catch (f) {}
  return (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / Math.pow(10, c);
}

export function subNumber(a, b) {
  let c, d, e;
  try {
    c = a.toString().split('.')[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split('.')[1].length;
  } catch (f) {
    d = 0;
  }
  return (e = Math.pow(10, Math.max(c, d))), (mulNumber(a, e) - mulNumber(b, e)) / e;
}

export function divNumber(a, b) {
  let c,
    d,
    e = 0,
    f = 0;
  try {
    e = a.toString().split('.')[1].length;
  } catch (g) {}
  try {
    f = b.toString().split('.')[1].length;
  } catch (g) {}
  return (
    (c = Number(a.toString().replace('.', ''))),
    (d = Number(b.toString().replace('.', ''))),
    mulNumber(c / d, Math.pow(10, f - e))
  );
}

export function browser(type) {
  const u = navigator.userAgent.toLowerCase();
  const { screen } = window;
  const versions = {
    // 移动终端浏览器版本信息
    trident: u.indexOf('trident') > -1, // IE内核
    presto: u.indexOf('presto') > -1, // opera内核
    webKit: u.indexOf('appleWebKit') > -1, // 苹果、谷歌内核
    gecko: u.indexOf('gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
    mobile: !!u.match(/appleWebKit.*mobile.*/), // 是否为移动终端
    ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), // ios终端
    android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, // android终端或者uc浏览器
    iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, // 是否为iPhone或者QQHD浏览器
    iPad: u.indexOf('ipad') > -1, // 是否iPad
    iPod: u.indexOf('ipod') > -1,
    webApp: u.indexOf('safari') === -1, // 是否web应该程序，没有头部与底部
    wx: u.indexOf('micromessenger') > -1,
    nokia: u.indexOf('nokia') > -1,
    pcwx: u.indexOf('windowswechat') > -1,
    pc: !/Android|iPhone|SymbianOS|Windows\s+Phone|iPad|iPod/i.test(u),
    // ie: u.indexOf('msie') > -1,
    ie:
      (u.indexOf('msie') > -1 || u.indexOf('edge') > -1 || u.indexOf('trident') > -1) &&
      u.indexOf('opera') === -1,
    x5: u.indexOf('mqqbrowser') > -1,
    weibo: u.indexOf('weibo') > -1 || u.indexOf('Weibo') > -1,
    iphoneX: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/) && screen.height >= 812, // ios终端
    iphone5: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/) && screen.height === 568, // ios终端
  };

  return versions[type];
}

export function stringTimeFormat(timeString) {
  if (!timeString) return '--';
  return timeString.replace(/(\d{4})(\d{2})(\d{2})/, (match, $1, $2, $3) => [$1, $2, $3].join('-'));
}

export const showLoadingToast = (content = 'Loading……', duration = 0) =>
  Toast.loading(content, duration);

// export const showLoadingToast = (
//   content = 'Loading……',
//   duration = 0,
//   withIcon = true,
//   color = '#D5AB6D'
// ) =>
//   Toast.info(
//     <div>
//       {withIcon && (
//         <LoadingOutlined
//           style={{
//             color,
//             fontSize: '26px',
//             marginBottom: 6,
//           }}
//         />
//       )}
//       <p>{content} </p>
//     </div>,
//     duration
//   );
export const hideToast = () => Toast.hide();

export const showToast = (info, duration = 3) => Toast.info(info, duration);

// 浅拷贝一维数组转二维数组
export const handleArrayDimensionalFormat = (source, num) => {
  return source.reduce((v, item, index) => {
    let r = null;
    if (index % num === 0) {
      r = [...v, [item]];
    } else {
      v[v.length - 1].push(item);
      r = v;
    }
    return r;
  }, []);
};

// 设置cookie
export const setCookie = (cname, cvalue, exdays = 7) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toGMTString();
  // 获取当前主域
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const domain = parts.length > 2 ? '.' + parts.slice(-2).join('.') : '.' + hostname;
  document.cookie = cname + '=' + cvalue + '; ' + expires + ';domain=' + domain + ';path=/';
};

// 获取cookie
export async function getCookie(name) {
  try {
    // 兼容app-ip通信方案，cookie在app端获取
    if (window.location.host.includes('127.0.0.1')) {
      let cookieData = '';
      const cookieInfo = await jsGetCookie();
      if (cookieInfo?.code === 0 && cookieInfo.data?.cookie) {
        cookieData = cookieInfo.data.cookie;
        const regex = new RegExp(`${name}=([^;]*)`);
        const match = cookieData.match(regex);
        console.log('getCookie-----match: ', match);
        console.log('getCookie-----decodeURIComponent(match[1]): ', decodeURIComponent(match[1]));
        return match && match.length > 0 ? decodeURIComponent(match[1]) : '';
      }
    }
  } catch (e) {
    console.log('getCookie---------------error: ', e);
  }
  try {
    return document.cookie.match(new RegExp('(^' + name + '| ' + name + ')=([^;]*)')) == null
      ? ''
      : decodeURIComponent(RegExp.$2);
  } catch (e) {
    return document.cookie.match(new RegExp('(^' + name + '| ' + name + ')=([^;]*)')) == null
      ? ''
      : RegExp.$2;
  }
}

/**
 * 查询设备通知权限（4.7.0）
 */
export const getAndUpdateNotificationPermission = () => {
  jsCheckPermission(
    {
      permission: 'notification',
    },
    res => {
      if (res?.code === 0 && res.data) {
        const notificationPermission = res.data?.result;
        let showNotificationTip = false;
        if (!notificationPermission) {
          // 取本地保存上次关闭时间
          const lastCloseMonth = getStorage(MESSAGE_CLOSE_NOTICE_STORAGE_KEY);
          const nowTime = moment().format('YYYY-MM');
          if (!lastCloseMonth || nowTime > lastCloseMonth) showNotificationTip = true;
        }
        window.g_app._store.dispatch({
          type: 'user/save',
          payload: {
            showNotificationTip,
          },
        });
      }
    }
  );
};

/*
 * 生成指定长度的随机字符串
 * @param {number} length 字符串长度
 * @param {string} str 字符集
 * @returns {string} 生成的字符串
 */
export const randomString = (
  length = 32,
  str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
) => {
  let result = '';
  for (var i = length; i > 0; --i) result += str[Math.floor(Math.random() * str.length)];
  return result;
};

/**
 * 格式化数字
 * @param {number} num 数字
 * @returns {string} 格式化后的数字
 */
export function formatNumber2W(num, unit = '万', fixedNum = 0) {
  if (!num && num !== 0) return '--';
  if (num >= 10000) {
    // 转换为 W
    return (num / 10000).toFixed(fixedNum) + unit;
  }
  return num.toString();
}
